<ng-template #content>
  <div [ngStyle]="isDialog ? dialogStyle : {}">
    <div>
      <div
        class="edit-orders-header row-layout"
        style="justify-content: space-between; background-color: white"
      >
        <div style="flex: 1; padding-right: 1rem">
          <app-input
            label="Suchtext"
            (valueChange)="onSearchChange($event)"
          ></app-input>
        </div>
        <div
          class="row-layout"
          style="flex: 2; padding-left: 1rem; justify-content: flex-end"
        >
          <div
            class="row-layout"
            style="align-items: center; margin-right: 24px"
          >
            <div style="margin-right: 0.5rem">Von:</div>
            <app-date-picker
              [no-hint]="true"
              [value]="startDate"
              (valueChange)="onStartDateChange($event)"
            ></app-date-picker>
          </div>
          <div
            class="row-layout"
            style="align-items: center; margin-right: 24px"
          >
            <div style="margin-right: 0.5rem">Bis:</div>
            <app-date-picker
              [no-hint]="true"
              [value]="endDate"
              (valueChange)="onEndDateChange($event)"
            ></app-date-picker>
          </div>
          <div style="margin-right: 24px; padding-top: 8px">
            <button
              mat-button
              (click)="search()"
              class="light-bg-color"
              style="height: 40px"
            >
              Suche starten
            </button>
          </div>
          <div
            *ngIf="isAdmin"
            style="margin-left: 12px; margin-right: 24px; padding-top: 8px"
          >
            <button
              mat-flat-button
              (click)="addDate()"
              class="light-bg-color"
              style="width: unset; border-radius: 4px; padding: 4px 8px"
            >
              <mat-icon>add</mat-icon>
              <span style="font-weight: 600; display: inline-block"
                >Termin</span
              >
            </button>
          </div>
        </div>
      </div>
    </div>

    <div [ngStyle]="isDialog ? dialogContentStyle : componentContentStyle">
      <div
        *ngIf="isLoading"
        style="font-size: 1.5rem; width: 100%; padding: 1rem"
      >
        <div style="width: 100%; text-align: center">
          Daten werden gesucht und geladen.
        </div>
        <br />
        <mat-progress-bar mode="buffer" color="primary"></mat-progress-bar>
      </div>
      <table class="team-plan-table" *ngIf="!isLoading">
        <thead></thead>
        <tbody>
          <ng-container *ngFor="let week of weeks">
            <tr>
              <td
                *ngFor="let day of currentDayNames"
                style="min-width: 5rem; vertical-align: top"
              >
                <div
                  class="cell-header"
                  *ngIf="week[day]"
                  [ngClass]="
                    colors[day][0] +
                    ' ' +
                    (week[day] && week[day].current ? 'current-day' : '')
                  "
                >
                  <div
                    class="row-layout cell-header-date"
                    style="justify-content: stretch; padding-left: 0"
                  >
                    <div style="width: 1.6rem; margin-right: 1rem">
                      <button
                        *ngIf="isAdmin"
                        mat-icon-button
                        (click)="add(week, day)"
                      >
                        <mat-icon class="team-plan-add-icon">add</mat-icon>
                      </button>
                    </div>
                    <div style="text-align: center; flex: 1">
                      {{ week[day].date }}
                    </div>
                    <div style="width: 1.6rem"></div>
                  </div>
                  <div
                    class="row-layout"
                    style="
                      border-bottom: 2px solid white;
                      justify-content: stretch;
                      padding-left: 0;
                    "
                  >
                    <div style="width: 1.6rem; margin-right: 1rem"></div>
                    <div class="cell-header-dayname" style="flex: 1">
                      {{ names[day] }}
                    </div>
                    <div style="width: 1.6rem"></div>
                  </div>
                </div>
                <ng-container *ngIf="week[day] && week[day].dates">
                  <div
                    *ngFor="let d of week[day].dates; let $index = index"
                    class="row-layout team-plan-date-cell"
                    [ngClass]="colors[day][($index + 1) % 2]"
                  >
                    <div style="padding: 0.5rem">
                      {{ d.from }}
                      <br />
                      {{ d.to }}
                      <br />
                      <button mat-icon-button (click)="editDate(week, day, d)">
                        <mat-icon *ngIf="isAdmin" class="team-plan-edit-icon"
                          >edit</mat-icon
                        >
                        <mat-icon *ngIf="!isAdmin" class="team-plan-edit-icon"
                          >visibility</mat-icon
                        >
                      </button>
                    </div>
                    <div style="flex: 1; padding: 0.25rem">
                      <div *ngIf="d.order?.customer">
                        <div class="team-plan-date-name">
                          {{ d.order.customer.name }}
                        </div>
                      </div>
                      <div
                        style="padding: 0.5rem 0; border-top: 1px solid grey"
                      >
                        <div
                          style="
                            margin-bottom: 0.5rem;
                            white-space: nowrap;
                            overflow-wrap: none;
                          "
                        >
                          Montageort:
                          <div
                            [ngClass]="[
                              'team-date-complete',
                              completeColors[day][($index + 1) % 2]
                            ]"
                            *ngIf="d.order?.status == 2"
                          >
                            ausgeführt
                          </div>
                        </div>
                        <ng-container *ngIf="d.order">
                          <ng-container
                            *ngIf="'' + d.order.montage_loctype === '0'"
                          >
                            <div
                              class="team-plan-date-address"
                              *ngIf="d.order?.customer?.address"
                            >
                              {{ d.order.customer.address }}
                            </div>
                            <div
                              class="team-plan-date-zip-city"
                              *ngIf="
                                d.order?.customer?.zip ||
                                d.order?.customer?.city
                              "
                            >
                              {{ d.order?.customer?.zip || "" }}
                              {{ d.order?.customer?.city || "" }}
                            </div>
                          </ng-container>
                          <ng-container
                            *ngIf="'' + d.order.montage_loctype === '1'"
                          >
                            <div style="font-weight: 600">MAG-Werkstatt</div>
                          </ng-container>

                          <ng-container
                            *ngIf="'' + d.order.montage_loctype === '2'"
                          >
                            <div
                              class="team-plan-date-address"
                              *ngIf="d.order?.montage_address"
                            >
                              {{ d.order.montage_address }}
                            </div>
                            <div
                              class="team-plan-date-zip-city"
                              *ngIf="
                                d.order?.montage_zip || d.order?.montage_city
                              "
                            >
                              {{ d.order?.montage_zip || "" }}
                              {{ d.order?.montage_city || "" }}
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                      <!-- Kontakt -->
                      <ng-container *ngIf="d.order">
                        <div
                          *ngIf="
                            d.order?.customer?.phone ||
                            d.order?.customer?.mobile
                          "
                          class="team-plan-date-separator"
                        ></div>

                        <div
                          *ngIf="d.order.customer.phone"
                          class="team-plan-date-phone"
                        >
                          Tel: {{ d.order.customer.phone }}
                        </div>
                        <div
                          *ngIf="d.order.customer.mobile"
                          class="team-plan-date-mobile"
                        >
                          Mobil: {{ d.order.customer.mobile }}
                        </div>

                        <div
                          *ngIf="
                            d.order?.customer?.phone ||
                            d.order?.customer?.mobile
                          "
                          class="team-plan-date-separator"
                        ></div>
                        <!---->
                        <div *ngIf="d.order.articlenr" style="margin-top: 8px">
                          Artikelnummer:<br />
                          {{ d.order.articlenr }}<br />
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </td>
            </tr>
            <tr style="height: 1em">
              <td colspan="7"></td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<div *ngIf="isDialog">
  <div
    mat-dialog-title
    style="position: relative; top: 0; left: 0; width: 100%"
  >
    <div
      style="flex: 1; text-align: center; font-weight: 600; font-size: 1.2rem"
    >
      {{ team_name }}
    </div>
    <!--
    <div style="width: 100%; text-align: center;">Terminplanner</div>
    <div style="position:absolute; left:0; top:0;"></div>
  --></div>
  <mat-dialog-content class="mat-typography" style="overflow-y: hidden">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </mat-dialog-content>
  <div mat-dialog-actions style="width: 100%">
    <div class="row-layout" style="justify-content: flex-end; width: 100%">
      <button mat-button (click)="closeDialog()">Schließen</button>
    </div>
  </div>
</div>
<div *ngIf="!isDialog" class="edit-orders-content">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
